import Footer from "../../components/Footer/Footer";
import PageHeader from "../../components/TopHeader/PageHeader";
import { CenterContainer, Container } from "./DevicePageStyle";

import DeviceSideNav from "../../components/SideNav/DeviceSideNav";
import Seo from "../../components/Seo";
import requiredAuth from "../../components/requiredAuth";
import DeviceList from "../../components/Template/DeviceList";
import { useTranslation } from "react-i18next";

function DevicePage() {
  const { t } = useTranslation();
  return (
    <Container>
      <Seo title={t(`device`)} />
      <PageHeader title={t(`device`)} />
      <CenterContainer>
        <DeviceSideNav />
        <DeviceList />
      </CenterContainer>
      <Footer />
    </Container>
  );
}

export default requiredAuth(DevicePage);
